import React from 'react';
import { motion } from 'framer-motion';

const Features = () => {
    const features = [
        { title: 'Reliable Car Rental Services', desc: 'Well-maintained vehicles with professional drivers ensuring safe and comfortable corporate travel.', icon: '🚗' },
        { title: 'Verified Property Leasing Solutions', desc: 'Trusted residential, commercial, and industrial properties with complete documentation support.', icon: '🏢' },
        { title: 'Professional & Transparent Service', desc: 'Clear communication, reliable processes, and dedicated support for every client.', icon: '🤝' }
    ];

    return (
        <section
            className="relative py-24 bg-cover bg-center bg-fixed"
            style={{ backgroundImage: "url('/city-background.jpg')" }}
        >
            {/* Background image ko saaf dikhane ke liye dark overlay */}
            <div className="absolute inset-0 bg-black/50"></div>

            <div className="relative max-w-7xl mx-auto px-6 text-center text-white">
                <motion.h3
                    initial={{ opacity: 0, y: -20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    className="text-orange-500 font-bold tracking-[0.2em] uppercase text-sm mb-4"
                >
                    Drive Safe. Drive Smart.
                </motion.h3>
                <motion.h2
                    initial={{ opacity: 0, y: -20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="text-5xl md:text-6xl font-extrabold mb-20 text-white"
                >
                    THE RAJ KURUMA EXPERIENCE
                </motion.h2>

                {/* Grid Container */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {features.map((item, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            // Frosted Glass Effect (White translucent)
                            className="bg-white/10 backdrop-blur-md p-10 border border-white/20 shadow-2xl transition-all duration-300 flex flex-col items-center text-center hover:bg-white/20"
                        >
                            <div className="text-6xl mb-6">{item.icon}</div>
                            <h4 className="font-bold text-2xl mb-4 text-white">{item.title}</h4>
                            <p className="text-gray-100 leading-relaxed text-sm">{item.desc}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Features;